// WebDesing.jsx
import { useLayoutEffect, useRef } from 'react';
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./WebDesing.css";
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Raiz from "./raiz";

gsap.registerPlugin(ScrollTrigger);

function WebDesing({
  backgroundUrl = "/assets/fondosoftware.png", // <-- cambiá por tu imagen (o pasalo por props)
}) {
  const root = useRef(null);

  useLayoutEffect(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    const ctx = gsap.context(() => {
      const defaultScrollConfig = {
        start: 'top 85%',
        toggleActions: 'play none none none',
      };

      // Hero animation
      const heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });
      heroTl
        .fromTo(
          '.hero-bg-image',
          { autoAlpha: 0, scale: 1.03 },
          { autoAlpha: 1, scale: 1, duration: 1.1, ease: 'power2.out' }
        )
        .fromTo(
          '.hero-content > *',
          { autoAlpha: 0, y: 24 },
          { autoAlpha: 1, y: 0, duration: 0.9, stagger: 0.12 },
          '-=0.6'
        );

      // Diagonal separator
      gsap.fromTo(
        '.diagonal-separator',
        { scaleX: 0, transformOrigin: 'left center' },
        {
          scaleX: 1,
          duration: 1.2,
          ease: 'expo.inOut',
          scrollTrigger: {
            trigger: '.content-section',
            ...defaultScrollConfig,
          },
        }
      );

      // Intro text
      gsap.fromTo(
        '.intro-text p',
        { autoAlpha: 0, y: 30 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.intro-text',
            ...defaultScrollConfig,
          },
        }
      );

      // Service cards
      gsap.fromTo(
        '.service-card',
        { autoAlpha: 0, y: 60, scale: 0.9 },
        {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          duration: 0.8,
          stagger: 0.15,
          ease: 'back.out(1.2)',
          scrollTrigger: {
            trigger: '.services-grid',
            ...defaultScrollConfig,
          },
        }
      );
    }, root);

    return () => ctx.revert();
  }, []);

  return (
    <div ref={root}>
    <NavBar />
    {/* Hero Section */}
      <section className="webdesign-hero">
        <img 
          src={backgroundUrl} 
          alt="Background" 
          className="hero-bg-image"
        />
        <div className="hero-content">
          <h1 className="hero-title">Diseño y desarrollo de páginas web</h1>
          <p className="hero-subtitle">
            Creamos sitios modernos, rápidos y optimizados para convertir visitas en clientes.
            Podés contratar solo la web, o un servicio completo con hosting y mantenimiento.
          </p>
        <div className="hero-cta">
          <Raiz 
            onClick= {("https://wa.me/5493584322356?text=Hola!%20Me%20interesa%20solicitar%20un%20presupuesto%20para%20una%20página%20web")}
            text="Solicitar presupuesto"
          />
        </div>
        </div>
        <div className="diagonal-separator"></div>
      </section>

      {/* Content Section */}
      <section id="planes" className="content-section">
        <div className="intro-text">
          <p>
            Ofrecemos soluciones web adaptadas a tus necesidades. Elegí el servicio que mejor 
            se ajuste a tu proyecto y llevá tu negocio al siguiente nivel.
          </p>
        </div>

        <div className="services-grid">
          <article className="service-card">
            <div className="service-header">
              <h3>Solo página web</h3>
              <div className="service-line"></div>
            </div>
            <p>
              Ideal si ya tenés dominio/hosting o lo gestionás por tu cuenta.
            </p>
            <ul className="service-list">
              <li>Landing / Sitio institucional</li>
              <li>Diseño responsive (celu, tablet, PC)</li>
              <li>Optimización de rendimiento y SEO básico</li>
              <li>Integración WhatsApp / formularios</li>
            </ul>
          </article>

          <article className="service-card">
            <div className="service-header">
              <h3>Web + Hosting</h3>
              <div className="service-line"></div>
            </div>
            <p>
              Nosotros dejamos todo listo y funcionando online.
            </p>
            <ul className="service-list">
              <li>Configuración de dominio y DNS</li>
              <li>Hosting (según necesidad)</li>
              <li>SSL / HTTPS</li>
              <li>Deploy y monitoreo inicial</li>
            </ul>
          </article>

          <article className="service-card">
            <div className="service-header">
              <h3>Mantenimiento</h3>
              <div className="service-line"></div>
            </div>
            <p>
              Para que tu web siempre esté segura, actualizada y rápida.
            </p>
            <ul className="service-list">
              <li>Actualizaciones y mejoras</li>
              <li>Backups y seguridad</li>
              <li>Soporte técnico</li>
              <li>Contenido: cambios y ajustes</li>
            </ul>
          </article>
        </div>        
      </section>

      <Footer />
    </div>
  );
}

export default WebDesing;
